import { createSelector } from 'reselect';

const looseItemDashboardData = (state) => state.looseItemDashboardData;

export const selectLooseItemDashboardTablesData = () =>
  createSelector([looseItemDashboardData], (state) => state.looseItemDashboardTablesData);

export const selectLooseItemDashboardConfig = () =>
  createSelector([looseItemDashboardData], (state) => state.looseItemDashboardConfig);
